<script>
  import PasswordToggle from './PasswordToggle.svelte';
  
  export let value = '';
  export let id = 'password';
  export let placeholder = 'Enter your password';
  export let required = false;
  export let disabled = false;
  export let autocomplete = '';
  export let className = '';
  export let ariaInvalid = false;
  export let ariaDescribedby = undefined;
  
  let showPassword = false;
  
  function togglePassword() {
    showPassword = !showPassword;
  }
</script>

<div class="password-input">
  {#if showPassword}
    <input 
      type="text" 
      {id}
      bind:value
      {required} 
      {disabled}
      {placeholder}
      {autocomplete}
      class={className}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedby}
      on:blur
      on:input
      on:focus
      {...$$restProps}
    />
  {:else}
    <input 
      type="password" 
      {id}
      bind:value
      {required} 
      {disabled}
      {placeholder}
      {autocomplete}
      class={className}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedby}
      on:blur
      on:input
      on:focus
      {...$$restProps}
    />
  {/if}
  <button type="button" class="toggle-password" on:click={togglePassword} aria-label={showPassword ? 'Hide password' : 'Show password'}>
    <PasswordToggle {showPassword} />
  </button>
</div>

<style>
  .password-input {
    position: relative;
  }

  input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  @media (max-width: 768px) {
    input {
      padding: 0.625rem 0.875rem !important;
    }
  }
  
  input::placeholder {
    color: rgba(0, 0, 0, 0.25);
  }
  
  input:hover {
    border: 1px solid #d1d5db;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
  }
  
  input:focus {
    outline: none;
    border-color: #f0b429;
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
    box-shadow: 0 0 0 3px rgba(240, 180, 41, 0.1);
  }
  
  input.field-invalid {
    border: 1px solid var(--color-negative) !important;
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
    box-shadow: 0 0 0 1px rgba(252, 108, 107, 0.15);
  }

  input.field-invalid:hover {
    border: 1px solid var(--color-negative) !important;
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
  }

  input.field-invalid:focus {
    border: 1px solid var(--color-negative) !important;
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
    box-shadow: 0 0 0 3px rgba(252, 108, 107, 0.2);
  }

  input.error {
    border-color: var(--color-negative);
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
  }
  
  input.error:hover {
    border-color: var(--color-negative);
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
  }
  
  input.error:focus {
    border-color: var(--color-negative);
    border-width: 1px;
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
  }
  
  input:disabled {
    background-color: #f3f4f6 !important;
    color: black !important;
    cursor: not-allowed;
    opacity: 0.7;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    color: #666;
  }
</style> 